// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { hot } from 'react-hot-loader';
import { random } from 'lodash';
import { Button, Modal } from 'angieslist-react-components';
import { urlCatalog, analytics, tracker } from 'angieslist-app-platform';
import { CloseIcon } from '@angi/icons';
import { defaultPageProps } from './analyticsDefaultProperties';
import inboxActions from '../../modules/inbox/common/inboxActions';
import MarketingImg from './automations-onboarding.png';
import './automationsOnboardingModal.scss';

type Props = {
  onClose: (e: any) => mixed,
  show: bool,
  spId: string,
  getAutomationTemplates: typeof inboxActions.getAutomationTemplates,
  setAutomationMessage: typeof inboxActions.setAutomationMessage,
};

class AutomationsOnboardingModal extends React.Component<Props> {
  componentDidMount() {
    const {
      spId,
      show,
      getAutomationTemplates,
      setAutomationMessage,
    } = this.props;
    if (show) {
      getAutomationTemplates(spId)
        .then((res) => {
          const { templates } = res.value.body;
          const randomTemplate = templates[random(templates.length - 1)];
          setAutomationMessage(spId, randomTemplate.text);
        });
    }
  }

  render(): React.Node {
    const {
      show,
      spId,
      onClose,
    } = this.props;

    const closeModalAndRedirect: (() => void) = () => {
      tracker.track('Item Clicked', {
        activityLocation: 'automated message onboarding modal',
        description: 'try it now',
        serviceProviderId: spId,
      }, {}, () => {
        const automationsUrl = `${urlCatalog.office.inbox(spId)}?automations=true`;
        window.location.href = automationsUrl;
      });
    };

    const handleCloseModal = (loc) => {
      tracker.track('Item Clicked', {
        activityLocation: 'automated message onboarding modal',
        description: loc,
        serviceProviderId: spId,
      });

      onClose();
    };

    return (
      <Modal show={show} onHide={() => handleCloseModal('dismiss')} dialogClassName="automation-onboarding-modal-dialog">
        <Modal.Header className="automation-onboarding-modal-header">
          <img
            alt="Automations..."
            src={MarketingImg}
            className="automation-onboarding-modal-image"
          />
          <CloseIcon
            className="automation-onboarding-modal-close-button"
            onClick={() => handleCloseModal('close')}
          />
        </Modal.Header>
        <Modal.Body className="automation-onboarding-modal-body">
          <div className="automation-onboarding-modal-body-content">
            <div className="automation-onboarding-modal-header">
              Introducing automated messages.
            </div>
            <div className="automation-onboarding-modal-text">
              Respond faster to new leads when you set up automated messages.
            </div>
          </div>
          <Button
            className="automation-onboarding-modal-button"
            id="automations-modal--try-it-button"
            bsSize="small"
            onClick={closeModalAndRedirect}
          >
            Try it now
          </Button>
        </Modal.Body>
      </Modal>
    );
  }
}

const automationsOnboardingAnalytics = {
  page: {
    name: 'Automated message onboarding modal',
    properties: {
      ...defaultPageProps,
    },
  },
};

export default (hot(module)(compose(
  analytics({ ruleset: automationsOnboardingAnalytics }),
  connect(state => ({
    inbox: state.inbox,
  }), {
    ...inboxActions,
  }),
  pure,
)(AutomationsOnboardingModal)): any);




// WEBPACK FOOTER //
// ./src/app/browser/AutomationsOnboardingModal.js